import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { EnhancedAllServicesData, CompleteServiceData } from '../data/EnhancedAllServicesData';
import '../styles/ServiceDetailPage.css';
import '../styles/ServiceSections.css';
import '../styles/EnhancedServiceDetailPage.css';


//components
import ServiceHeader from './ServiceSections/ServiceHeader';
import BenefitsCard from './ServiceSections/BenefitsCard';
import GridCard from './ServiceSections/GridCard';
import ServiceProcess from './ServiceSections/ServiceProcess';
import ScrollableCardSlider from './ServiceSections/ScrollableCardSlider';
import ServiceRichText from './ServiceSections/ServiceRichText';
import WhatYouGet from './ServiceSections/whatYouGet';
import IndustryUseCases from './ServiceSections/IndustryUseCases';
import ServiceFAQ from './ServiceSections/ServiceFAQ';
import ServiceList from './ServiceSections/ServiceList';
import ServiceFeature from './ServiceSections/ServiceFeature';
import ScrollPinSection from './ScrollPinSection';

// import ServiceContent from './ServiceSections/ServiceContent';


const EnhancedServiceDetailPage: React.FC = () => {
  const { serviceId } = useParams<{ serviceId: string }>();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Get service data 
  const service: CompleteServiceData | null = serviceId ? EnhancedAllServicesData[serviceId] : null;
  console.log(service);

  if (!service) {
    return (
      <div className="service-detail-page">
        <div className="service-not-found">
          <h1>404</h1>
          <p>The service you're looking for doesn't exist or may have been moved.</p>
          <Link to="/services" className="back-to-services-btn">
            Explore All Services
          </Link>
        </div>
      </div>
    );
  }

  const renderSections = () => {
    const sections = [];

      // Hero section
      sections.push(
        <ServiceHeader
          key="hero"
          icon={service.hero.icon}
          heading={service.hero.title}
          subheading={service.hero.subtitle}
          description={service.hero.description}
          category={service.hero.category}
          leftImage={service.hero.leftImage}
          rightImage={service.hero.rightImage}
          features={service.hero.highlights}
        />
      );

      /* <ServiceHeroSection {...service.hero} /> */
      
      /* <DividerShowcase /> */

      // <ServiceContent sections={service.content.sections} />

      /* Main Content Sections */
      if (service.content?.sections) {
        service.content.sections.forEach((section, index) => {
          
          switch (section.type) {

            case 'info-cards':
              sections.push(
                  <ScrollPinSection
                    key={`${section.type}-${index}`}
                    sectionHeading={section.title}
                    cardData={section.info_cards_content || []}
                  />
              );
              break;

            case 'animated-info-cards':
              sections.push(
                  <ScrollPinSection
                    key={`${section.type}-${index}`}
                    sectionHeading={section.title}
                    cardData={section.animated_info_cards_content || []}
                  />
              );
              break;

            case 'benefits-card':
              sections.push(
                <div 
                className={`benefits-card ${section.background || ''}`} key={`${section.type}-${index}`}>
                  <BenefitsCard
                    key={`${section.type}-${index}`}
                    sectionHeading={section.title}
                    benefitsCards={section.benefits_card_content || []}
                  />
                </div>
              );
              break;
            
            case 'grid-cards':
              sections.push(
                <div 
                className={`grid-cards ${section.background || ''}`} key={`${section.type}-${index}`}>
                  <GridCard
                    key={`${section.type}-${index}`}
                    sectionHeading={section.title}
                    gridCards={section.grid_cards_content || []}
                  />
                </div>
              );
              break;
            
            case 'process':
              sections.push(
                <div 
                className={`serviceprocess ${section.background || ''}`} key={`${section.type}-${index}`}>
                  <ServiceProcess
                    key={`${section.type}-${index}`}
                    sectionHeading={section.title}
                    steps={section.processSteps || []}
                  />
                </div>
              );
              break;
            
            case 'tools':
              sections.push(
                <ScrollableCardSlider
                  key={`${section.type}-${index}`}
                  sectionHeading={section.title}
                  items={section.tools || []}
                />
              );
              break;
            
            case 'features':
              sections.push(
                <div className={`fetaure ${section.background || ''}`} key={`${section.type}-${index}`}>
                  <WhatYouGet
                    sectionHeading={section.title}
                    content={section.features_content || []}
                  />
                </div>
              );
              break;

            case 'rich-text':
              sections.push(
                <div className={`rich-text ${section.background || ''}`} key={`${section.type}-${index}`}>
                  <ServiceRichText
                    title={section.title}
                    content={section.rich_text_content || []}
                  />
                </div>
              );
              break; 
            
            case 'list':
              sections.push(
                <ServiceList
                  sectionHeading={section.title}
                  items={section.items || []}
                />
              );
              break;   

            case 'benefits':
              sections.push(
                  <ServiceFeature
                    sectionHeading={section.title}
                    content={section.content || []}
                  />
              );
              break;   
              
          }
        });
      }

      // industry use cases section
      if (service.industryUseCases) {
        sections.push(
          <IndustryUseCases 
            key="industryUseCases" 
            {...service.industryUseCases} 
          />
        );
      }

      // FAQ section
      if (service.faq) {
        sections.push(
          <ServiceFAQ 
            key="faq" 
            {...service.faq} 
          />
        );
      }

    return sections;
  };


  return (
    <div className="service-detail-page">
            {renderSections()}
    </div>
  );
};

export default EnhancedServiceDetailPage; 